(function ($) {
    /**
     * Autoplay Optimizer
     * Uses IntersectionObserver to pause/play videos and sliders when they enter/leave the viewport.
     * Safely handles slick sliders to respect native pauseOnHover and click interactions.
     */
    
    const optimizerObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const $el = $(entry.target);
            
            // Handle Slick Sliders safely
            if ($el.hasClass('slick-initialized')) {
                if (entry.isIntersecting) {
                    // Only resume if it was originally supposed to autoplay,
                    // and only if the user isn't currently hovering over it.
                    if ($el.data('slick')?.options?.autoplay === true) {
                        if (!$el.is(':hover') && !$el.find(':focus').length) {
                            $el.slick('slickPlay');
                        }
                    }
                } else {
                    $el.slick('slickPause');
                }
            }

            // Handle HTML5 Videos
            const $videos = $el.is('video') ? $el : $el.find('video');
            $videos.each(function() {
                if (entry.isIntersecting) {
                    this.play().catch(() => {}); // Catch play() errors (e.g. user hasn't interacted)
                } else {
                    this.pause();
                }
            });
            
            // Handle Third-party IFrames (Youtube/Vimeo)
            const $iframes = $el.is('iframe') ? $el : $el.find('iframe');
            $iframes.each(function() {
                const player = this;
                const postVideo = (command) => {
                    if (player.contentWindow) {
                        player.contentWindow.postMessage(JSON.stringify(command), "*");
                    }
                };

                // Check for Youtube
                if (player.src.indexOf('youtube.com') > -1) {
                    if (entry.isIntersecting) {
                        postVideo({ "event": "command", "func": "playVideo" });
                    } else {
                        postVideo({ "event": "command", "func": "pauseVideo" });
                    }
                }
                // Check for Vimeo
                else if (player.src.indexOf('player.vimeo.com') > -1) {
                    if (entry.isIntersecting) {
                        postVideo({ method: "play" });
                    } else {
                        postVideo({ method: "pause" });
                    }
                }
            });
        });
    }, { 
        rootMargin: '100px 0px', // Start playing slightly before entering viewport
        threshold: 0.01 
    });

    const haloAutoplay = {
        observedElements: new Set(),
        
        init: function () {
            this.observeExisting();
            this.setupMutationObserver();
            this.setupGlobalClickResume();
        },

        observeExisting: function () {
            // Target sliders and video containers
            $('.slick-slider, .video-section, video, iframe').each((i, el) => {
                this.addObserver(el);
            });
        },

        addObserver: function (el) {
            if (!this.observedElements.has(el)) {
                optimizerObserver.observe(el);
                this.observedElements.add(el);
            }
        },

        setupGlobalClickResume: function() {
            // Fulfills requirement: "make sure it start autoplay when i click somewhere else"
            // Useful to unstick sliders that got locked up by quick-shop swatches or focus events.
            $(document).on('click', function(e) {
                $('.slick-initialized').each(function() {
                    const $slider = $(this);
                    if ($slider.data('slick')?.options?.autoplay === true) {
                        // If the click was NOT inside this specific slider, resume it
                        if (!$.contains(this, e.target)) {
                            $slider.slick('slickPlay');
                        }
                    }
                });
            });
        },

        setupMutationObserver: function () {
            // Watch for dynamically added videos or sliders
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1) { // Element node
                            const $node = $(node);
                            if ($node.hasClass('slick-slider') || $node.is('video') || $node.is('iframe') || $node.find('.slick-slider, video, iframe').length) {
                                this.addObserver(node);
                            }
                        }
                    });
                });
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    };

    $(document).ready(function () {
        // Immediate hook to catch newly initialized Slick sliders and observe them
        $(document).on('init', '.slick-slider', function(e, slick) {
            haloAutoplay.addObserver(slick.$slider[0]);
        });

        // Delay slightly to allow initial theme scripts to run
        setTimeout(() => {
            haloAutoplay.init();
        }, 100);
    });
})(jQuery);
